import { Routes } from '@angular/router';

export const Full_ROUTES: Routes = [
  {
    path: 'workspace',
    loadChildren: () => import('../../workspace/workspace.module').then(m => m.WorkspaceModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('../../pages/dashboard/dashboard.module').then(m => m.DashboardModule)
  },
  {
    path: 'userb',
    loadChildren: () => import('../../pages/ok-admin/ok-admin.module').then(m => m.OkAdminModule)
  },
  {
    path: 'userbgroup',
    loadChildren: () => import('../../pages/user-b-group/user-b-group.module').then(m => m.UserBGroupModule)
  },
  {
    path: 'company',
    loadChildren: () => import('../../pages/ok-company/ok-company.module').then(m => m.OkCompanyModule)
  },
  {
    path: 'task',
    loadChildren: () => import('../../pages/tasks/task.module').then(m => m.TaskModule)
  },
  {
    path: 'process',
    loadChildren: () => import('../../pages/process/process.module').then(m => m.ProcessModule)
  },
  {
    path: 'invoice',
    loadChildren: () => import('../../pages/invoice/invoice.module').then(m => m.InvoiceModule)
  },
  {
    path: 'recurringinvoice',
    loadChildren: () => import('../../pages/recurring-invoice/recurring-invoice.module').then(m => m.RecurringInvoiceModule)
  },
  {
    path: 'takenInvoice',
    loadChildren: () => import('../../pages/taken-invoice/recurring-invoice.module').then(m => m.TakenInvoiceModule)
  },
  {
    path: 'externalbilling',
    loadChildren: () => import('../../pages/external-billing/external-billing.module').then(m => m.ExternalBillingModule)
  },
  {
    path: 'inssabsence',
    loadChildren: () => import('../../pages/inss-absence/inss-absence.module').then(m => m.InssAbsenceModule)
  },
  {
    path: 'das',
    loadChildren: () => import('../../pages/das/das.module').then(m => m.DasModule)
  },
  {
    path: 'request',
    loadChildren: () => import('../../pages/request/request.module').then(m => m.RequestModule)
  },
  {
    path: 'requestNotification',
    loadChildren: () => import('../../pages/requestNotification/requestNotification.module').then(m => m.RequestNotificationModule)
  },
  {
    path: 'tax',
    loadChildren: () => import('../../pages/tax/tax.module').then(m => m.TaxnModule)
  },
   {
    path: 'ofx',
    loadChildren: () => import('../../pages/ofx-file/ofx-file.module').then(m => m.OfxFileModule)
  }
];
